<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="accordion-card   tw-bg-white tw-overflow-visible"
 [ngClass]="{'tablet:!tw-bg-[#F8F8F8] tablet:!tw-rounded-lg tablet:!tw-p-2 max-md:!tw-px-5 max-md:!tw-py-[8px]': itemCardOriginalDescription,
  'tw-sml-border tw-rounded-2xl': !itemCardOriginalDescription
}">
  <div class="main-header tw-cursor-pointer {{accordionClass}}"
    [ngClass]="{
    '!tw-border-b !tw-pb-2': isOpen && itemCardOriginalDescription,
    'tw-px-8 tw-pt-8': isOpen && !itemCardOriginalDescription, 
    'tw-p-8': !isOpen && !itemCardOriginalDescription,
  }"  (click)="toggleAccordion()">
    <div class="tw-flex tw-flex-col" [ngClass]="{'tw-gap-1': !itemCardOriginalDescription}">
      <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
        <div class="heading tw-font-bold tw-text-lg tw-leading-6 tablet:tw-text-2xl tw-text-dark-grey" [ngClass]="{'!tw-font-bold !tw-text-base !tw-text-[#041519]': itemCardOriginalDescription}">
          {{ heading }}
        </div>
        <i-icon [name]="isOpen ? 'arrow-up-thin' : 'arrow-down-thin'" class="tw-text-dark-grey-2 !tw-w-3 !tw-h-3 tablet:tw-w-[18px] tablet:tw-h-[18px]"></i-icon>
      </div>
      <div class="sub-heading tw-font-normal tw-text-sm tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5 tw-text-mercury-600">
        {{ subHeading }}
      </div>
    </div>
  </div>
  @if (containDomElement){
  <div [hidden]="!isOpen" class="tw-pt-5 content"
  [ngClass]="!itemCardOriginalDescription ? 'tw-pb-8 tw-px-8 ' : '!tw-pt-[10px]'"
  >
    <ng-content select="[DomElement]"></ng-content>
  </div>
  } @else{
  <div *ngIf="isOpen" class="tw-pt-5 content"
  [ngClass]="!itemCardOriginalDescription ? 'tw-pb-8 tw-px-8' : ' !tw-pt-[10px]'"
 >
    <ng-content></ng-content>
  </div>
  }
</div>
